module.exports = __webpack_public_path__ + "static/media/bw.a7934381.svg";